import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7496dd6d")

_pushScopeId("data-v-7496dd6d")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Invest")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "hidden lg:inline" }, " / Farm", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Portfolio ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" fBeets ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: `app-nav-toggle bg-gray-50 dark:bg-gray-${_ctx.darkModeBg}`
  }, [
    _createVNode(_component_router_link, {
      to: { name: 'trade' },
      class: [
        'toggle-link px-6 rounded-r-lg',
        { [_ctx.activeClasses]: _ctx.isTradePage }
      ],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavTrade)))
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('trade')), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: { name: 'invest' },
      class: [
        'toggle-link px-6 rounded-l-lg',
        { [_ctx.activeClasses]: _ctx.isInvestPage }
      ],
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavInvest)))
    }, {
      default: _withId(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }, 8, ["class"]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: { name: 'my-portfolio' },
          class: [
        'toggle-link px-4 rounded-l-lg',
        { [_ctx.activeClasses]: _ctx.isPortfolioPage }
      ],
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavHome)))
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: { name: 'fbeets' },
          class: [
        'toggle-link px-4 rounded-l-lg',
        { [_ctx.activeClasses]: _ctx.isFreshBeetsPage }
      ],
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trackGoal(_ctx.Goals.ClickNavFreshBeets)))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ], 2))
})